import type { ControllerConfigType } from '@/features/controller/configuration/types'
import { TextEditorLanguage } from '@/features/controller/configuration/types'
import { ControllerConfigTypeId } from '@/features/controller/configuration/types'
import { ControllerRouteInformation } from '@/features/controller/constants'

export const RaspiPropertiesConfigType: ControllerConfigType = {
  id: ControllerConfigTypeId.RaspiProperties,
  name: 'App Config (raspi-custom.properties)',
  navigationPath: ControllerRouteInformation.CONTROLLER_CONFIG_RASPI_PROPERTIES.navigationPath,
  shortName: 'App Config (legacy)',
  textEditorLanguage: TextEditorLanguage.ini,
  veryShortName: 'properties',
}

export const AppJsonConfigType: ControllerConfigType = {
  id: ControllerConfigTypeId.AppJson,
  name: 'App Config (JSON)',
  navigationPath: ControllerRouteInformation.CONTROLLER_CONFIG_APP_JSON.navigationPath,
  shortName: 'App Config (new)',
  textEditorLanguage: TextEditorLanguage.json,
  veryShortName: 'JSON',
}

export const ResourceJsonConfigType: ControllerConfigType = {
  id: ControllerConfigTypeId.ResourceJson,
  name: 'Resource Config (JSON)',
  navigationPath: ControllerRouteInformation.CONTROLLER_CONFIG_RESOURCE_JSON.navigationPath,
  shortName: 'Resource Config',
  textEditorLanguage: TextEditorLanguage.json,
  veryShortName: 'Resource',
}

export function getControllerConfigType(id: ControllerConfigTypeId) {
  switch (id) {
    case ControllerConfigTypeId.RaspiProperties:
      return RaspiPropertiesConfigType
    case ControllerConfigTypeId.AppJson:
      return AppJsonConfigType
    case ControllerConfigTypeId.ResourceJson:
      return ResourceJsonConfigType
  }
}
